/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
    isSplash: true, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Hannan Max (Hannanahmad Shaikh)",
  description:
    "Canadian tech entrepreneur, CEO & Founder of North Cipher Valley Inc. Full-stack developer and AI innovator building CiphLy, CipherAura, and RidesPool. GDG Sudbury Organizer.",
  og: {
    title: "Hannan Max | Hannanahmad Shaikh - Tech Entrepreneur & Developer",
    type: "website",
    url: "https://www.hannanmax.com/",
    site_name: "Hannan Max",
    image: "https://www.hannanmax.com/android-icon-192x192.png",
  },
};

//Home Page
const greeting = {
  title: "Hannan Max",
  logo_name: "Hannan Max",
  nickname: "Hannanahmad Shaikh",
  subTitle:
    "Tech entrepreneur, full-stack developer, and AI innovator. Founder & CEO of North Cipher Valley Inc., building AI-driven consumer solutions, NFC marketing platforms, and smart security hardware across multiple subsidiaries. Experienced in shipping production-grade software — from Flutter mobile apps and Next.js platforms to custom BLE firmware and on-device ML pipelines. GDG Sudbury Organizer, mentoring 200+ students and professionals across Northern Ontario.",
  resumeLink:
    "https://drive.google.com/file/d/1sxkJS0NfLSXxpeln-gwSRXxiGz9ml4c3/view?usp=sharing",
  portfolio_repository: "https://github.com/hannanmax",
  hire_me: "https://api.whatsapp.com/send?phone=12896001062&text=Hey%20There,%20I%20would%20like%20to%20hire%20you...",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/hannanmax",
    fontAwesomeIcon: "fa-github",
    backgroundColor: "#181717",
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/hannanmax/",
    fontAwesomeIcon: "fa-linkedin-in",
    backgroundColor: "#0077B5",
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/hannanmax_/",
    fontAwesomeIcon: "fa-instagram",
    backgroundColor: "#E4405F",
  },
  {
    name: "YouTube",
    link: "https://www.youtube.com/channel/UCP6ATvQ5igEoX7JI6gQIENg",
    fontAwesomeIcon: "fa-youtube",
    backgroundColor: "#FF0000",
  },
  {
    name: "GooglePlay",
    link: "https://play.google.com/store/apps/dev?id=7261248402572870851",
    fontAwesomeIcon: "fa-google-play",
    backgroundColor: "#000000",
  },
  {
    name: "Gmail",
    link: "mailto:hannanmaxdev@gmail.com",
    fontAwesomeIcon: "fa-google",
    backgroundColor: "#D14836",
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/HannanMaxDev/",
    fontAwesomeIcon: "fa-facebook-f",
    backgroundColor: "#1877F2",
  },
];

const skills = {
  data: [
    {
      title: "CEO & Founder — North Cipher Valley Inc.",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Leading a tech ecosystem with 6 subsidiaries, 7 employees, and 30+ partners",
        "⚡ Built CiphLy Inc. — NFC-powered marketing platform (Flutter + Firebase), 1,100+ tags distributed",
        "⚡ Architected CipherAura — AI body cameras with on-device face recognition, $103K funded",
        "⚡ Developed RidesPool — production carpooling platform (Next.js 16 + Flutter + Supabase)",
      ],
      softwareSkills: [
        {
          skillName: "Flutter",
          fontAwesomeClassname: "vscode-icons:file-type-flutter",
          style: { backgroundColor: "transparent" },
        },
        {
          skillName: "React",
          fontAwesomeClassname: "logos:react",
          style: { backgroundColor: "transparent" },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: { color: "#FFCA28" },
        },
        {
          skillName: "Node.js",
          fontAwesomeClassname: "logos:nodejs-icon",
          style: { backgroundColor: "transparent" },
        },
      ],
    },
    {
      title: "Full-Stack & Mobile Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building cross-platform mobile apps with Flutter, React Native, Kotlin, and Swift",
        "⚡ Developing web platforms with React.js, Next.js, Node.js, Express, Django, and Laravel",
        "⚡ Database design with PostgreSQL, MySQL, SQLite, MongoDB, Firestore, Drizzle ORM, and Prisma",
        "⚡ Deploying on Firebase, Supabase, AWS, Google Cloud, Railway, and Vercel",
      ],
      softwareSkills: [
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "logos:javascript",
          style: { backgroundColor: "transparent" },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "logos:typescript-icon",
          style: { backgroundColor: "transparent" },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "logos:python",
          style: { backgroundColor: "transparent" },
        },
        {
          skillName: "Dart",
          fontAwesomeClassname: "logos:dart",
          style: { backgroundColor: "transparent" },
        },
        {
          skillName: "Kotlin",
          fontAwesomeClassname: "logos:kotlin",
          style: { backgroundColor: "transparent" },
        },
        {
          skillName: "Swift",
          fontAwesomeClassname: "logos:swift",
          style: { backgroundColor: "transparent" },
        },
      ],
    },
    {
      title: "AI, Machine Learning & IoT",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ On-device ML with TensorFlow Lite, Google ML Kit, and MobileFaceNet for face recognition",
        "⚡ Integrating LLMs — OpenAI GPT, Gemini, Claude, and Ollama into production applications",
        "⚡ IoT hardware development with ESP32-S3, BLE/NimBLE protocols, NFC, and PlatformIO",
        "⚡ Building AI smart glasses (CipherAura Cam) and smart home assistants (Homaura)",
      ],
      softwareSkills: [
        {
          skillName: "TensorFlow",
          fontAwesomeClassname: "logos:tensorflow",
          style: { backgroundColor: "transparent" },
        },
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: { color: "#4285F4" },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: { color: "#FF9900" },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: { color: "#1488C6" },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: { color: "#326CE5" },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: { color: "#336791" },
        },
      ],
    },
    {
      title: "Community Leadership & GDG Organizing",
      fileName: "GDGSudbury",
      skills: [
        "⚡ GDG Sudbury Organizer (2023–Present) — DevFest, Build with AI, TechSafe & Healthy 2026",
        "⚡ Founded GDG on Campus Cambrian, grew community to 200+ tech students and professionals",
        "⚡ Speaker at TechSafe & Healthy 2026 (MedGemma, Gemini CLI sessions)",
        "⚡ Attended Google Cloud Next 2025 in Las Vegas",
      ],
      softwareSkills: [
        {
          skillName: "GOOGLE",
          fontAwesomeClassname: "simple-icons:google",
          style: { color: "#02569B" },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: { color: "#2EC866" },
      profileLink: "https://www.hackerrank.com/16bcah06",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: { color: "#20BEFF" },
      profileLink: "https://www.kaggle.com/hannan_max",
    },
  ],
};

// Live Projects Page
const liveprojectsite = {
  liveprojectsite: [
    {
      siteName: "CiphLy",
      image: "homeworkhelper.png",
      alt_name: "CiphLy - NFC Marketing Platform",
      style: { color: "#2EC866" },
      link: "https://ciphly.com",
    },
    {
      siteName: "bio.ciphly.com",
      image: "homeworkhelper.png",
      alt_name: "CiphLy Bio Links",
      style: { color: "#2EC866" },
      link: "https://bio.ciphly.com",
    },
  ],
};

const websites = {
  websites: [
    {
      title: "CiphLy Inc.",
      subtitle: "NFC Marketing Platform",
      logo_path: "homeworkhelper.png",
      alt_name: "CiphLy",
      duration: "2025 - Present",
      descriptions: [
        "⚡ NFC-powered marketing platform turning physical interactions into measurable brand exposure.",
        "⚡ Flutter + Firebase mobile app with bio-link management, smart keychain NFC integration, and sponsor portal.",
        "⚡ 1,100+ NFC tags distributed at GDG DevFest Toronto and Waterloo. ~$200K valuation.",
      ],
      website_link: "https://ciphly.com",
    },
    {
      title: "CipherAura",
      subtitle: "AI Security Body Cameras",
      logo_path: "homeworkhelper.png",
      alt_name: "CipherAura",
      duration: "2024 - Present",
      descriptions: [
        "⚡ AI-powered body cameras for private security with on-device face recognition (MobileFaceNet/TFLite).",
        "⚡ Custom BLE protocol with ESP32-S3, AES-256 encrypted biometric storage, GPS tracking.",
        "⚡ $103K funded, ~$700K valuation, beta testing with California security firms.",
      ],
      website_link: "#",
    },
    {
      title: "RidesPool",
      subtitle: "Carpooling Platform for Canada",
      logo_path: "homeworkhelper.png",
      alt_name: "RidesPool",
      duration: "2025 - Present",
      descriptions: [
        "⚡ Production carpooling platform built with Next.js 16, React 19, Flutter, and Supabase PostgreSQL.",
        "⚡ Driver verification, booking management, vehicle management with Better Auth and Drizzle ORM.",
        "⚡ Zero platform fees — drivers keep 100%. Revenue from Premium Driver Verification ($9.99/yr).",
      ],
      website_link: "#",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Post-Graduate Diploma — Business Analytics (GPA: 3.95)",
      subtitle: "CAMBRIAN COLLEGE",
      logo_path: "collegelogo.png",
      alt_name: "Cambrian College",
      duration: "Sep 2023 - June 2024",
      descriptions: [
        "⚡ Business intelligence, data analytics, predictive modeling, and decision-making frameworks.",
        "⚡ Applied data science tools: R, Python, SQL, Tableau, Power BI for real-world business cases.",
      ],
      website_link: "https://cambriancollege.ca",
    },
    {
      title: "Post-Graduate Diploma — Mobile Application Development (GPA: 4.0)",
      subtitle: "CAMBRIAN COLLEGE",
      logo_path: "collegelogo.png",
      alt_name: "Cambrian College",
      duration: "Sep 2022 - June 2023",
      descriptions: [
        "⚡ Cross-platform mobile development: Java, Kotlin, Swift, Flutter, Firebase integration.",
        "⚡ UI/UX design, API integration, app store deployment, and agile development practices.",
      ],
      website_link: "https://cambriancollege.ca",
    },
    {
      title: "Bachelor of Computer Applications (CGPA: 9.24)",
      subtitle: "UKA TARSADIA UNIVERSITY",
      logo_path: "utu.png",
      alt_name: "UTU",
      duration: "Aug 2016 - May 2019",
      descriptions: [
        "⚡ Core CS: Data Structures, Algorithms, DBMS, OS, Computer Architecture, AI.",
        "⚡ Courses in Deep Learning, Data Science, Cloud Computing, and Full Stack Development.",
        "⚡ Merit cum Means Scholarship — awarded to top 10% of students.",
      ],
      website_link: "http://utu.ac.in",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Machine Learning",
      subtitle: "- Andrew Ng",
      logo_path: "stanford_logo.png",
      certificate_link: "",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
    {
      title: "Deep Learning",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link: "",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link: "",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "Data Science",
      subtitle: "- Alex Aklson",
      logo_path: "ibm_logo.png",
      certificate_link: "",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Big Data",
      subtitle: "- Kim Akers",
      logo_path: "microsoft_logo.png",
      certificate_link: "",
      alt_name: "Microsoft",
      color_code: "#D83B0199",
    },
    {
      title: "Advanced Data Science",
      subtitle: "- Romeo Kienzler",
      logo_path: "ibm_logo.png",
      certificate_link: "",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Advanced ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link: "",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "DL on Tensorflow",
      subtitle: "- Laurence Moroney",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link: "",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "Fullstack Development",
      subtitle: "- Jogesh Muppala",
      logo_path: "coursera_logo.png",
      certificate_link: "",
      alt_name: "Coursera",
      color_code: "#2A73CC",
    },
    {
      title: "Kuberenetes on GCP",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link: "",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
    {
      title: "Cryptography",
      subtitle: "- Saurabh Mukhopadhyay",
      logo_path: "nptel_logo.png",
      certificate_link: "",
      alt_name: "NPTEL",
      color_code: "#FFBB0099",
    },
    {
      title: "Cloud Architecture",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link: "",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Research, and Community Leadership",
  description:
    "CEO & Founder of North Cipher Valley Inc. with 6 subsidiaries. Full-stack developer with 7+ years of experience shipping mobile, web, IoT, and AI applications. GDG Sudbury Organizer mentoring 200+ professionals across Northern Ontario.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "CEO & Founder",
          company: "North Cipher Valley Inc.",
          company_url: "https://northciphervalley.com",
          logo_path: "hmdevcoders.png",
          duration: "Sep 2024 — PRESENT",
          location: "Sudbury, ON, Canada",
          description:
            "Leading a tech ecosystem with 6 subsidiaries (CiphLy, CipherAura, RidesPool, etc.), 7 employees, and 30+ partners. Building AI-driven solutions, NFC marketing platforms, and smart security hardware. Also providing IT solutions and digital transformation for 10+ Sudbury small businesses.",
          color: "#0879bf",
        },
        {
          title: "Research Assistant & Mobile Application Developer",
          company: "Cambrian College R&D",
          company_url: "https://cambriancollege.ca/rd/",
          logo_path: "cambrianrandd.jpeg",
          duration: "Jan 2023 — Oct 2024",
          location: "Sudbury, ON, Canada",
          description:
            "Developed cutting-edge mobile and web applications for interdisciplinary research projects. Led design of ML-powered solutions including predictive data models. Lead developer on E.X.I.T. Life Ready — finalist at Venture North Pitch 2025 (NORCAT).",
          color: "#0879bf",
        },
        {
          title: "Artificial Intelligence Researcher",
          company: "ThreeWise AI",
          company_url: "#",
          logo_path: "hmdevcoders.png",
          duration: "May 2024 — Aug 2024",
          location: "Toronto, ON (Remote)",
          description:
            "Led AI-driven projects integrating Generative AI into enterprise applications. Spearheaded custom AI models for predictive insights and automated decision-making, reducing operational inefficiencies by 40%.",
          color: "#0879bf",
        },
        {
          title: "Sales Associate (Technology)",
          company: "Staples Canada",
          company_url: "https://staples.ca",
          logo_path: "hmdevcoders.png",
          duration: "Sep 2023 — PRESENT",
          location: "Sudbury, ON, Canada",
          description:
            "Deliver tailored technology solutions across departments. Built a custom Python-based product display card generator (ReportLab + barcode integration) to solve missing display card problems store-wide.",
          color: "#0879bf",
        },
        {
          title: "Brand Champion",
          company: "Codalio (via North Cipher Valley Inc.)",
          company_url: "https://codalio.com",
          logo_path: "hmdevcoders.png",
          duration: "Sep 2025 — Oct 2025",
          location: "Sudbury, ON, Canada",
          description:
            "Strengthened Codalio's presence in the Canadian startup ecosystem. Presented AI-powered coding and prototyping workshop modules at NORCAT Sudbury.",
          color: "#0879bf",
        },
        {
          title: "Mobile Application Developer & CEO",
          company: "HMDevCoders Inc.",
          company_url: "https://www.linkedin.com/company/hmdevcoders/",
          logo_path: "hmdevcoders.png",
          duration: "Sep 2018 — May 2024",
          location: "Gujarat, India",
          description:
            "Engineered commercially successful mobile applications across iOS and Android. Integrated third-party APIs, cloud services, and real-time data processing. Maintained a 95% client retention rate.",
          color: "#9b1578",
        },
      ],
    },
    {
      title: "Community & Volunteering",
      experiences: [
        {
          title: "Organizer",
          company: "GDG Sudbury (Google Developer Group)",
          company_url: "https://gdg.community.dev/gdg-sudbury/",
          logo_path: "github_logo.png",
          duration: "Mar 2023 — PRESENT",
          location: "Sudbury, ON, Canada",
          description:
            "Organize DevFest, Build with AI, TechSafe & Healthy, and Silicon Crater Tech Meet events. Mentored 200+ students and professionals. Represented GDG Sudbury at Laurentian University orientation and regional summits.",
          color: "#4285F4",
        },
        {
          title: "Chapter Lead",
          company: "Canada Learning Code — Sudbury",
          company_url: "#",
          logo_path: "github_logo.png",
          duration: "Feb 2024 — May 2024",
          location: "Sudbury, ON, Canada",
          description:
            "Directed large-scale digital literacy programs driving 30% increase in community participation. Managed cross-functional volunteer teams promoting gender diversity in technology.",
          color: "#4285F4",
        },
        {
          title: "President",
          company: "Cambrian Developer Club",
          company_url: "#",
          logo_path: "cdclogo.jpeg",
          duration: "Feb 2023 — Oct 2024",
          location: "Sudbury, ON, Canada",
          description:
            "Led the CDC for 1.5+ years, organizing hackathons, tech talks, Women Techmakers events, and app development workshops across the college.",
          color: "#4285F4",
        },
        {
          title: "Social Media Manager",
          company: "Jack.org",
          company_url: "https://jack.org",
          logo_path: "github_logo.png",
          duration: "Jul 2023 — PRESENT",
          location: "Sudbury, ON, Canada",
          description:
            "Mental health advocacy through social media content curation and community engagement.",
          color: "#4285F4",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "Building production-grade applications across AI, IoT, mobile, and web. From NFC marketing platforms to AI-powered security cameras and smart home assistants.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "hannanmax.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with AI, Flutter, React, Next.js, IoT, Cloud, and full-stack development.",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "Greater Sudbury, Ontario, Canada",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://g.page/hannan_max?share",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+1 (289) 600-1062",
  },
  blogSection: {
    title: "Companies",
    subtitle:
      "North Cipher Valley Inc. — CiphLy Inc. — CipherAura — RidesPool",
    link: "https://northciphervalley.com",
    avatar_image_path: "blogs_image.svg",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  liveprojectsite,
  websites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
};
